@if (loading) {
<div class="p-2">
  <p-skeleton styleClass="custom-skeleton-header"></p-skeleton>
  <p-skeleton styleClass="custom-skeleton-body"></p-skeleton>
</div>
} @else {
<div class="container-style mb-2">
  <div class="d-flex flex-wrap gap-3">
    <div><span class="fw-bold">Pedido:</span> {{ orderData.consecutive }}</div>
    <div><span class="fw-bold">Fecha Pedido:</span> {{ dateOrder | date:'dd/MM/yyyy' }}</div>
    <div><span class="fw-bold">Vendedor:</span> {{ orderData.sellerCodeName }}</div>
  </div>
</div>
<div class="container-style">
  <div class="row">
    @for (observation of observations; track observation.label) {
    <div class="col-12 col-lg-4 mb-2 mb-lg-0">
      <div class="observation-card">
        <label class="form-label d-block observation-title">{{ observation.label }}</label>
        @if (observation.value) {
        <p class="observation-text">{{ observation.value }}</p>
        } @else {
        <p class="observation-text fst-italic text-muted">Sin observación</p>
        }
      </div>
    </div>
    }
  </div>
</div>
}
<div class="d-flex justify-content-end mt-2">
  <app-custom-button [title]="'Salir'" [label]="'Salir'" [variant]="undefined" [severity]="'danger'"
    (onClick)="close()"></app-custom-button>
</div>